module.exports = __webpack_public_path__ + "static/media/vials.5f3e96ea.svg";